<template>
  <b-container>
    <b-row>
      <h3>{{msg}}</h3>
    </b-row>
    <div v-show="hasVideo">
    <b-row  align-h="center">
      <b-col cols="12" lg="6" class="text-center">
        <youtube ref="youtube" :video-id="videoId" :player-vars="playerVars" @ready="readyVideo" @playing="playingVideo"></youtube>
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col class="text-center">
        <button @click.prevent="playVideo">play</button>
        <button @click.prevent="pauseVideo">pause</button>
        <button @click.prevent="stopVideo">stop</button>
        <!-- <router-link to="/yt2">YT2</router-link> -->
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col class="text-center">
           <b-link class="pl-3" v-for="(id,ix) in videoArr" :key="ix" @click.prevent="changeVideo(id)">{{id}}</b-link>
      </b-col>
    </b-row>
    </div>
  </b-container>
</template>

<script>
/* eslint-disable */

// 5 second video
// https://www.youtube.com/watch?v=QC8iQqtG0hg
// https://www.youtube.com/watch?v=uaGmdm3Aiq0
//
// Freedive https://www.youtube.com/watch?v=SrZRMoi-yO4
// Bowie https://www.youtube.com/watch?v=kJ095S0MmnA
// Prine https://www.youtube.com/watch?v=ZogciFl-udY
// 
// Youtube API
// https://developers.google.com/youtube/iframe_api_reference#Events
// https://developers.google.com/youtube/player_parameters

// Vue Youtube
// https://github.com/anteriovieira/vue-youtube

import youtubeMixin from "@/plugins/youtubeMixin";

let data = {
  videoUrl: "https://www.youtube.com/watch?v=QC8iQqtG0hg",
  videoArr: ["QC8iQqtG0hg", "SrZRMoi-yO4", "kJ095S0MmnA", "kJ095S0MmnA", "ZogciFl-udY"],
  videoId: "QC8iQqtG0hg",
  playerVars: {
    autoplay: 1,
    rel: 0
  },
  msg: "Youtube Vue?",
  hasVideo: false
};

export default {
  name: "YoutubeVue",
  data() {
    return data;
  },
  mixins: [youtubeMixin],  
  computed: {
    player() {
      return this.$refs.youtube.player
    }
  },  
  methods: {
      changeVideo(id) {
          this.videoId = id
      },
    readyVideo() {
      console.log("o/ we are ready!!!");
    },
    playingVideo() {
      console.log("o/ we are watching!!!");
    },
    playVideo() {
      // this.$refs.youtube.player.playVideo();
      this.player.playVideo();  // see computed()
    },
    pauseVideo() {
      this.player.pauseVideo();
    },
    stopVideo() {
      this.player.stopVideo();
    }
  },
  created () {
      this.videoId = this.videoArr[0]
  },
  async mounted() {
    let res = await this.checkYoutube();
    if (res.hasYoutube) {
      this.hasVideo = true;
    } else {
        console.log(`YOUTUBE BLOCKED!!`)
    }
  },
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#ytplayer {
  display: block;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/YoutubeVue.vue